module.exports = __webpack_public_path__ + "img/predicciones_max.1d2693c8.png";